module.exports = __webpack_public_path__ + "static/media/pm_mobile_in_hand_illustration.aa9d082b.jpg";